import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { ReportTrialBalanceSection } from '@/features/reports/trial-balance'

/** The reporting module's own trial balance, as an addressable screen of its own. */
export function ReportsTrialBalancePage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Trial balance"
        description="What the general ledger says, for a branch or the whole institution, as at a business date."
      />

      <ReportTrialBalanceSection />
    </>
  )
}
